import { type SubmissionLock, createSubmissionLock } from '@/lib/submissionLock';
import { useCallback, useRef, useState } from 'react';

export function useSubmissionLock<T>() {
  const lockRef = useRef<SubmissionLock<T> | null>(null);
  if (!lockRef.current) {
    lockRef.current = createSubmissionLock<T>();
  }
  const lock = lockRef.current;
  const [isLocked, setIsLocked] = useState(false);

  const begin = useCallback(
    (payload: T) => {
      const attempt = lock.begin(payload);
      if (attempt) setIsLocked(true);
      return attempt;
    },
    [lock]
  );

  const release = useCallback(() => {
    lock.release();
    setIsLocked(false);
  }, [lock]);

  const reset = useCallback(() => {
    lock.reset();
    setIsLocked(false);
  }, [lock]);

  return { begin, release, reset, isLocked };
}
